import React, { useEffect, useState } from "react";
// react-bootstrap components
import { Card, Container, Row, Col } from "react-bootstrap";
import { apiService } from "../../../service/ApiService";
import { useHistory } from "react-router-dom";
import { notificationService } from "../../../service/NotificationService";
import HippoTable from "components/ReactTable/HipposReactTable";
import CreateTableBtn from "components/Buttons/CreateTableBtn";
import FreePriceColumn from "components/Custom/FreePriceColumn";
import EditButton from "views/Components/EditButton";
import DeleteButton from "views/Components/DeleteButton";
import { ClipLoader } from "react-spinners";

import { useTranslation } from "react-i18next";

function AttributeListPage() {
  const {
    t,
  } = useTranslation();

  const history = useHistory();
  const [data, setData] = useState([]);
  const [alert, setAlert] = useState(null);
  const [showLoader, setShowLoader] = useState(true);

  const columns = [
    {
      Header: "ID",
      accessor: "id",
    },
    {
      Header: t("tables.headers.designation"),
      accessor: "name",
    },
    {
      Header: t("tables.headers.creditCost"),
      accessor: "credits",
    },
    {
      Header: t("tables.headers.multipleChoice"),
      accessor: "reusable",
    },
    {
      Header: t("tables.headers.actions"),
      accessor: "actions",
    },
  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        setShowLoader(true);
        const dataResponse = await apiService.get("api/v1/attributes");
        const data = dataResponse.data;
        // setData(addActions(data));
        setData(attachCustom(data));
      } catch (error) {
        console.error("Error fetching data:", error);
        notificationService.notifyWarn(error.message);
      } finally {
        setShowLoader(false);
      }
    };

    fetchData();
  }, []);

  const attachCustom = (data) => {
    const enhanced = data.map((el) => {
      el.actions = (
        <div className="actions-right d-flex float-right">
          <EditButton uri={`/admin/attribute/${el.id}`} />
          <DeleteButton handler={() => notificationService.notifyWarn(t("messages.deletionIsNotSupported"))} />
        </div>
      );
      el.reusable = <FreePriceColumn value={el.reusable} />;
      return el;
    });
    return _.sortBy(enhanced, ["order", "id"]);
  };

  return (
    <>
      {alert}
      <Container fluid>
        <Row>
          <Col md="12">
            <Card>
              <Card.Body>
                <Row>
                  <CreateTableBtn route={"/admin/attribute"} />
                </Row>
                <Row>
                  <Col>
                    {showLoader ? (
                      <div style={{ textAlign: "center", marginTop: "5vh", marginBottom: "5vh" }}>
                        <ClipLoader size={50} color={"#ff6fbc"} />
                      </div>
                    ) : (
                      <HippoTable data={data} columns={columns} className="-striped -highlight primary-pagination" />
                    )}
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default AttributeListPage;
